import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

// Components
import AppHelmet from "./AppHelmet";
import Notices from "./Notices";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import Body from "./Body";

// CSS
import "../css/app.css";

// State
import { getSiteInfo } from "../store/actions/siteInfo";
import { getTranslations } from "../store/actions/translations";

// Setup
import { setGoogleAnalyticsEnvironment } from "../utils/google-analytics";

const translationKey = "app";

class App extends Component {
	static initialAction(store, props) {
		let promises = [];
		let resTranslations =
			store !== null
				? getTranslations([], [translationKey], translationKey)
				: props.getTranslations([], [translationKey], translationKey);
		promises.push(resTranslations);

		let resSiteInfo = store !== null ? getSiteInfo() : props.getSiteInfo();
		promises.push(resSiteInfo);

		return promises;
	}

	componentWillMount() {
		// On client and site info has not been fetched yet
		// We are also assuming if no siteInfo, no translations ;)
		if (this.props.siteInfo.site === undefined) {
			Promise.all(App.initialAction(null, this.props));
		}

		if (typeof window !== "undefined") {
			setGoogleAnalyticsEnvironment(this.props.location.pathname);
		}
	}

	componentDidMount() {
		if (typeof window !== "undefined") {
			setGoogleAnalyticsEnvironment(this.props.location.pathname);
		}
	}

	render() {
		return (
			<div className="App">
				{/* <AppHelmet {...this.props} /> */}
				<Notices />
				<Header />
				<Body />
				<Footer />
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		siteInfo: state.siteInfo,
		user: state.user
	};
};

export default withRouter(
	connect(
		mapStateToProps,
		{ getSiteInfo, getTranslations }
	)(App)
);



// WEBPACK FOOTER //
// ./src/components/App.js